export default "__VITE_ASSET__7fbb6c8d__"